import { useState } from "react";
import { useRecoilValue } from "recoil";

import {
  AppEventTokenEnum,
  isFirstAccess,
  sendEventToAppMeasurementTool,
} from "@/utilities/capacitorLogic";
import { UserState } from "@/view_models/atoms";

export type PropertyViews = {
  operation: string;
  simulation: string;
  property: string;
  nearby: string;
};

export type ViewKeys = keyof PropertyViews;

// 物件詳細画面　表示切り替えを管理するhook
export const usePropertyViews = () => {
  const user = useRecoilValue(UserState);
  const [selectedView, setSelectedView] = useState<ViewKeys>("operation");

  const handleViewChange = (viewKey: ViewKeys) => {
    if (viewKey === "operation") {
      sendEventToAppMeasurementTool(
        isFirstAccess(user?.created_at)
          ? AppEventTokenEnum.PropertyTabBalanceOfPaymentsFirstAccess
          : AppEventTokenEnum.PropertyTabBalanceOfPaymentsSecondOnwardsAccess
      );
    }

    if (viewKey === "simulation") {
      sendEventToAppMeasurementTool(
        isFirstAccess(user?.created_at)
          ? AppEventTokenEnum.PropertyTabSimulationFirstAccess
          : AppEventTokenEnum.PropertyTabSimulationSecondOnwardsAccess
      );
    }

    if (viewKey === "property") {
      sendEventToAppMeasurementTool(
        isFirstAccess(user?.created_at)
          ? AppEventTokenEnum.PropertyTabInformationFirstAccess
          : AppEventTokenEnum.PropertyTabInformationSecondOnwardsAccess
      );
    }

    if (viewKey === "nearby") {
      sendEventToAppMeasurementTool(
        isFirstAccess(user?.created_at)
          ? AppEventTokenEnum.PropertyNearbyPriceFirstAccess
          : AppEventTokenEnum.PropertyNearbyPriceSecondOnwardsAccess
      );
    }

    setSelectedView(viewKey);
  };

  return {
    selectedView,
    handleViewChange,
  };
};
